export default "__VITE_ASSET__Nz6IKMGx__"